import { useUserInfoStore } from "@/stores/userInfo";
import { Tabs } from "antd-mobile";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import styles from './index.module.scss';
export const pageTabs = [{
  id: 'normal',
  title: '普通市场',
  url: '/root/orders?type=normal'
}, {
  id: 'block',
  title: '区块链市场',
  url: '/root/orders?type=block'
}];
export const ContentTabs = (props: {
  active: string;
}) => {
  const navigate = useNavigate();
  const onChange = (activeKey: string) => {
    const tab = pageTabs.find(tab => tab.id === activeKey);
    if (tab) {
      navigate(tab.url, {
        replace: true
      });
    }
  };
  return <Tabs activeKey={props.active} onChange={onChange} className={styles.tabs} data-sentry-element="Tabs" data-sentry-component="ContentTabs" data-sentry-source-file="index.tsx">
  {pageTabs.map(Tab => {
      return <Tabs.Tab title={Tab.title} key={Tab.id} destroyOnClose />;
    })}
  </Tabs>;
};